<form [formGroup]="form">
  <div class="header">
    <div class="header-box box">
      <span class="box-label">Banco: </span>
      <app-c-select
        class="header-select"
        width="250px"
        height="42px"
        placeholder="Selecione o Banco"
        formControlName="Bank"
        [data]="bankOpts"
      ></app-c-select>
    </div>
    <div class="header-box box">
      <span class="box-label">Canal de Vendas: </span>
      <app-c-select
        class="header-select"
        width="250px"
        height="42px"
        placeholder="Selecione o Canal"
        formControlName="Channel"
        [data]="channelOpts"
      ></app-c-select>
    </div>
    <div class="header-box box">
      <button
        type="button"
        class="box-btn"
        [disabled]="form.invalid"
        (click)="addConfig()"
      >
        Adicionar
      </button>
    </div>
  </div>
</form>
